import { NotificationSettings } from "./NotificationSettings";

export interface IOrgNotificationProfile {
    uuid:string;
    name:string;
    users:string[];
    settings:NotificationSettings;
}

export class OrgNotificationProfile {
    uuid:string = null;
    name:string = null;
    users:string[] = [];
    settings:NotificationSettings = new NotificationSettings();
    
    public constructor(init?:Partial<IOrgNotificationProfile>) {
        for (let prop in init) {
            if (this.hasOwnProperty(prop)) {
                this[prop] = init[prop];
            }
        }
    }
}